module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    attrs: {
      "align": "center"
    }
  }, [_c('ContactUsHeader'), _vm._v(" "), _c('div', {
    staticClass: "block-center mt-xl wd-xl"
  }, [_c('div', {
    staticClass: "panel panel-dark panel-flat"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resetFeedback),
      expression: "!resetFeedback"
    }],
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), (!_vm.linkExpired) ? _c('p', [_vm._v("Enter your email to receive instructions on how to reset your password.")]) : _vm._e(), _vm._v(" "), (_vm.linkExpired) ? _c('p', {
    staticClass: "text-red"
  }, [_c('strong', [_vm._v("Your reset password link has expired. Please request a new one.")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "mb-lg",
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateAndSubmitResetPassword($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "signupInputEmail1",
      "type": "email",
      "placeholder": "Enter email",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "form-icon icon-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock2"
    }
  }, [_vm._v(_vm._s(_vm.emailError))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default btn-lg mt-xl",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Reset password")]), _vm._v(" "), _c('div', {
    staticClass: "form-group has-feedback",
    class: {
      'has-error': _vm.resetPasswordError
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.resetPasswordError))])])])]), _vm._v(" "), (_vm.resetFeedback) ? _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(1)]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center pv"
  }, [_c('strong', [_vm._v("Reset Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', {
    attrs: {
      "id": "helpBlock7"
    }
  }, [_vm._v("Password Reset Email Sent.")]), _vm._v(" "), _c('br'), _vm._v("\n           If you entered a registered email in our system, we’ve sent you a link to reset your password. If you don’t receive an email within 5 minutes (and perhaps checked your spam and /or tried again to make sure email entered correctly),\n           "), _c('br'), _vm._v(" "), _c('strong', {
    attrs: {
      "id": "helpBlock8"
    }
  }, [_vm._v("then please contact us at info@calvertimpact.org or 800.248.0337.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21998ed0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPassword.vue
// module id = 2114
// module chunks = 1